import Typography from '@ui/typography'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { PdForm, PdFormProps } from './PdForm'
import InputsSection from '@ui/forms/InputsSection'

export function PdSection(props: PdFormProps) {
  const { t } = useTranslation(['vision'])
  const text = 'vision:pd'

  return (
    <InputsSection
      title={t(`${text}.header.title`)}
      desc={t(`${text}.header.desc`)}
    >
      <PdForm {...props} />
    </InputsSection>
  )
}
